import createConverter from './lib/create_converter';
import ActiveCall from 'models/active_call';

export default createConverter(ActiveCall);
